import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:max-classes-per-file */
var Retryable = /*#__PURE__*/function () {
  function Retryable(invocable) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Retryable);

    this.invocable = invocable;
    this.options = options;

    _defineProperty(this, "attemptStartTime", new Date().getTime());

    _defineProperty(this, "attemptCount", 0);
  }

  _createClass(Retryable, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!true) {
                  _context.next = 18;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this.delayFor();

              case 4:
                _context.next = 6;
                return this.invocable();

              case 6:
                return _context.abrupt("return", _context.sent);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                this.attemptCount++;
                _context.next = 14;
                return this.shouldRetry(_context.t0);

              case 14:
                if (_context.sent) {
                  _context.next = 16;
                  break;
                }

                throw _context.t0;

              case 16:
                _context.next = 0;
                break;

              case 18:
                throw new Error('Something went wrong.');

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }, {
    key: "shouldRetry",
    value: function () {
      var _shouldRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
        var _ref, _ref$maxAttempts, maxAttempts, _ref$maxTime, maxTime, predicate;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = this.options.retry || {}, _ref$maxAttempts = _ref.maxAttempts, maxAttempts = _ref$maxAttempts === void 0 ? Infinity : _ref$maxAttempts, _ref$maxTime = _ref.maxTime, maxTime = _ref$maxTime === void 0 ? Infinity : _ref$maxTime, predicate = _ref.predicate;

                if (!(this.attemptCount >= maxAttempts || new Date().getTime() - this.attemptStartTime >= maxTime)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                return _context2.abrupt("return", predicate ? predicate(error, this.attemptCount) : !!error);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function shouldRetry(_x) {
        return _shouldRetry.apply(this, arguments);
      }

      return shouldRetry;
    }()
  }, {
    key: "delayFor",
    value: function delayFor() {
      var _ref2 = this.options.delay || {},
          _ref2$initialTime = _ref2.initialTime,
          initialTime = _ref2$initialTime === void 0 ? 500 : _ref2$initialTime,
          _ref2$maxTime = _ref2.maxTime,
          maxTime = _ref2$maxTime === void 0 ? Infinity : _ref2$maxTime,
          _ref2$exponentialBack = _ref2.exponentialBackoff,
          exponentialBackoff = _ref2$exponentialBack === void 0 ? true : _ref2$exponentialBack,
          _ref2$skipFirstDelay = _ref2.skipFirstDelay,
          skipFirstDelay = _ref2$skipFirstDelay === void 0 ? true : _ref2$skipFirstDelay,
          _ref2$jitter = _ref2.jitter,
          jitter = _ref2$jitter === void 0 ? true : _ref2$jitter;

      var baseDelayTime = jitter ? initialTime : initialTime / 2;
      var delayTime = this.attemptCount >= (skipFirstDelay ? 1 : 0) ? Math.min(maxTime, baseDelayTime * Math.pow(2, exponentialBackoff ? this.attemptCount : 1)) * (jitter ? Math.random() : 1) : 0;
      return new _Promise(function (resolve) {
        return window.setTimeout(resolve, delayTime);
      });
    }
  }]);

  return Retryable;
}();

export var RetryableBreakError = /*#__PURE__*/function (_Error) {
  _inherits(RetryableBreakError, _Error);

  var _super = _createSuper(RetryableBreakError);

  function RetryableBreakError() {
    _classCallCheck(this, RetryableBreakError);

    return _super.apply(this, arguments);
  }

  return RetryableBreakError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var RetryableAbortedError = /*#__PURE__*/function (_Error2) {
  _inherits(RetryableAbortedError, _Error2);

  var _super2 = _createSuper(RetryableAbortedError);

  function RetryableAbortedError() {
    _classCallCheck(this, RetryableAbortedError);

    return _super2.apply(this, arguments);
  }

  return RetryableAbortedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function retryable(_x2) {
  return _retryable.apply(this, arguments);
}

function _retryable() {
  _retryable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(invocable) {
    var options,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            return _context3.abrupt("return", new Retryable(invocable, options).execute());

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _retryable.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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